const tattoos = [
    {
        title: "Plague doctor sleeve",
        description: "Black and grey sleeve with mask and ornamental flow.",
        image: "/images/IMG_0774.jpeg",
        style: "black-grey",
    },
    {
        title: "Storm ship",
        description: "Dark seascape with lightning, ship details and soft shading. Done in 1 session.",
        image: "/images/IMG_0793.jpeg",
        style: "black-grey",
    },
    {
        title: "Mythology sleeve",
        description: "Zeus, snakes and architectural elements in black and grey realism.",
        image: "/images/IMG_0984.jpeg",
        style: "black-grey",
    },
    {
        title: "Warrior queen",
        description: "Detailed portrait with tiger headdress and ornamental accents. 1 full day session.",
        image: "/images/IMG_0991.jpeg",
        style: "black-grey",
    },
    {
        title: "Family memory",
        description: "Realistic hands, moonlight and family silhouette composition. 1 session.",
        image: "/images/IMG_2335.jpeg",
        style: "black-grey",
    },
    {
        title: "Angel portrait",
        description: "Black and grey angel figure with wings and cross. Took me 2 sessions to complete.",
        image: "/images/IMG_2780.jpeg",
        style: "black-grey",
    },
    {
        title: "Lion and rose",
        description: "Realistic lion portrait paired with a soft shaded rose. Was done in 2 sessions. ",
        image: "/images/IMG_2867.jpeg",
        style: "black-grey",
    },
    {
        title: "Lion split design",
        description: "Half-realism lion with linework and a blue eye accent. 1 session.",
        image: "/images/IMG_2902.jpeg",
        style: "black-grey",
    },
    {
        title: "Abstract brush shoulder",
        description: "Color abstract brush strokes with bold black movement and vivid accents. Took me about 9 hours to complete.",
        image: "/images/IMG_0989.jpeg",
        style: "color",
    },
    {
        title: "RHCP musician portrait",
        description: "Color portrait with stage lighting, guitar details and purple shadows. Took me about 9 hours.",
        image: "/images/IMG_0996.jpeg",
        style: "color",
    },
    {
        title: "Hundred dollar bill",
        description: "Realistic money tattoo with warm gold tones and detailed linework. 1 session",
        image: "/images/IMG_2499.jpeg",
        style: "color",
    },
    {
        title: "Japanese sunset",
        description: "Color landscape with red sky, blue water and torii gate silhouette.",
        image: "/images/IMG_2833.jpeg",
        style: "color",
    },
    {
        title: "Broken mask portrait",
        description: "Vivid portrait composition with red, blue and soft realism details. 2 sessions.",
        image: "/images/IMG_2868.jpeg",
        style: "color",
    },
    {
        title: "Crowned cat",
        description: "Playful color cat portrait with blue eyes, crown and watercolor splashes. 1 session.",
        image: "/images/IMG_2957.jpeg",
        style: "color",
    },
    {
        title: "Warrior Girl",
        description: "Graphic blackwork portrait with lion and sharp contrast. Took me 2 and half sessions.",
        image: "/images/IMG_2906.jpeg",
        style: "black-grey",
    },
    {
        title: "Rose realism",
        description: "Large black and grey roses with glowing heart and smooth tonal transitions. 1 session.",
        image: "/images/IMG_3991.jpeg",
        style: "black-grey",
    },
    {
        title: "Bambi florals",
        description: "Illustrative character piece with flowers and bold linework. 1 session.",
        image: "/images/IMG_4011.jpeg",
        style: "black-grey",
    },
    {
        title: "Puffin and vegvisir",
        description: "Bright Icelandic puffin with red and blue rune details. Took me about 3-4 hours",
        image: "/images/IMG_3685.jpeg",
        style: "color",
    },
    {
        title: "Joker mask close-up",
        description: "Color realism mask of Joker. 1 long session, about 9 hours.  ",
        image: "/images/IMG_3993.jpeg",
        style: "color",
    },
    {
        title: "Phoenix",
        description: "Dynamic Phoenix with graphic black shapes. 1 session. ",
        image: "/images/IMG_4010.jpeg",
        style: "color",
    },
    {
        title: "Eagle portrait and native American.",
        description: "Color portrait with eagle, feather details and warm skin tones. 3 sessions.",
        image: "/images/IMG_4015.jpeg",
        style: "color",
    },
    {
        title: "Harley and Joker",
        description: "Comic-inspired color piece with character portraits and playing card. 1 long session (9 hours).",
        image: "/images/IMG_6468.jpeg",
        style: "color",
    },
    {
        title: "Fantasy tree landscape",
        description: "Soft color landscape with twisted tree, waterfall and green hills. 1 session.",
        image: "/images/IMG_8287.jpeg",
        style: "color",
    },
    {
        title: "Skull and rose",
        description: "Black and grey skull composition with rose and candle details. was done in one long session.",
        image: "/images/IMG_4012.jpeg",
        style: "black-grey",
    },
    {
        title: "Realistic portrait",
        description: "Soft shaded chicano girl portrait. Took me about 4 hours.",
        image: "/images/IMG_4013.jpeg",
        style: "black-grey",
    },
    {
        title: "Prison Break Tattoo",
        description: "This shoulder piece took 2 sessions, about 10 hours in total",
        image: "/images/IMG_4018.jpeg",
        style: "black-grey",
    },
    {
        title: "Ghotic Window",
        description: "High contrast black and grey piece on the inner arm. Was done in 7-8 hours.",
        image: "/images/IMG_4020.jpeg",
        style: "black-grey",
    },
    {
        title: "Japanese Mask",
        description: "This forearm tattoo took me one long full day (about 9 hours)",
        image: "/images/IMG_7051.jpeg",
        style: "black-grey",
    },
    {
        title: "Norse compass sleeve",
        description: "Outer arm sleeve. Was done in 3 sessions",
        image: "/images/IMG_9307.jpeg",
        style: "black-grey",
    },
    {
        title: "Lucky duck sleeve",
        description: "Playful black and grey sleeve with cards, dice and compass details. Was done in 4 sessions.",
        image: "/images/IMG_9792.jpeg",
        style: "black-grey",
    },
    {
        title: "Dark muse. Healed tattoo.",
        description: "Moody portrait with hands, crescent moon and sharp blackwork accents. Took me 2 sessions to complete.",
        image: "/images/IMG_9803.jpeg",
        style: "black-grey",
    },
    {
        title: "Bear realism",
        description: "Roaring bear portrait with raindeer skeleton. done in 2 sessions.",
        image: "/images/IMG_9940.jpeg",
        style: "black-grey",
    },
];

export default tattoos;
